export const sortSizes = (a, b) => {
    const sizes = [
      'S',
      'S/M',
      'M/S',
      'M',
      'M/L',
      'L/M',
      'L',
      'XL/L',
      'L/XL',
      'XL',
      'XL/XXL',
      'XXL/XL',
      'XXL',
      'XXXL/XXL',
      'XXL/XXXL',
      'XXXL',
      'XXXXL/XXXL',
      'XXXL/XXXXL',
      'XXXXL',
      'XL/2XL',
      '2XL/XL',
      '2XL',
      '3XL/2XL',
      '2XL/3XL',
      '3XL',
      '4XL/3XL',
      '3XL/4XL',
      '4XL'
    ];
  
    const aIdx = sizes.indexOf(a.toUpperCase());
    const bIdx = sizes.indexOf(b.toUpperCase());
  
    if (aIdx < 0) {
      if (!isNaN(a) && !isNaN(b)) {
        return Number(a) - Number(b);
      }
      return !isNaN(a) ? -1 : 1;
    }
    if (bIdx < 0) {
      if (!isNaN(a) && !isNaN(b)) {
        return Number(a) - Number(b);
      }
      return !isNaN(b) ? -1 : 1;
    }
    return aIdx - bIdx;
  };

  export const sortVarian = (a, b) => {
    const priority = [
      'model',
      'bahan',
      'warna',
      'ukuran',
    ];
  
    const aIdx = priority.indexOf(a.toLowerCase());
    const bIdx = priority.indexOf(b.toLowerCase());
  
    return aIdx - bIdx;
  };